import { scoreDescription } from '../lib/score';

// What the overall score means, in Speechace's own words ("Very good and
// clearly intelligible."), under the score on the result in Manual and
// Automatic alike. Renders nothing while Speechace's bands are off.
export default function ScoreDescription({ score }) {
    const text = scoreDescription(score);
    if (!text) return null;
    return <p className="mt-1 text-sm text-stone-500">{text}</p>;
}
